// extracted by mini-css-extract-plugin
export default {"addLinkBtn":"styles_addLinkBtn__bGHRU","addLinkBtnIcon":"styles_addLinkBtnIcon__mUuDc","input":"styles_input__Lsd9-","first":"styles_first__Xkrko"};